import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./NewsCard.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getNewsData } from "service/AlertService.js";
import { getUserInfo } from "service/AuthService.js";
import { setNews } from "store/slices/AlertSlice";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Button } from "components";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import Notification from "utils/Notifications";
import { deleteNews } from "service/AlertService.js";
import userInfo from "utils/userInfo.js";
import YouTube from 'react-youtube';
import newswrap from 'assets/side_pane_new_icons/newspaper.svg'
import moment from 'moment';

const NewsCard = () => {
  const { t } = useTranslation('common')
  const [render,setRender] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const user_info = userInfo()
  const [openModal, setOpenModal] = useState(false);

  const [info_card, setInfo_card] = useState([]);

  const [data, setData] = useState([]);

  const dispatch = useDispatch();

  const { id } = useParams();

  const getData = async () => {
    try {
      let response = await getNewsData(id, data);
      for (const item of response.data) {
        let responseImage = await getUserInfo(item.user_id, data);
        item.image = responseImage.data.imeag;
      }
      

      dispatch(
        setNews({
          news: response.data,
        })
      );
    } catch (error) {
    }
  };
  useEffect(() => {
    getData();
    setRender(false)
   
  }, [render]);

  const news = useSelector((state) => state.alert.news);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);
  useEffect(() => {
    width < 600 && handleSideNavToggle();
  });
  function handleSideNavToggle() {
  }

  const handleClick = (item) => {
    setOpenModal(true);
    setInfo_card(item);
  };
  const text =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nec commodo ligula Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nec commodo ligula Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nec commodo ligula";
  const maxWords = 9;
  const limitWords = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    WebkitLineClamp: maxWords,
  };
 
  const handleDelete = async (id) => {
    try {
      let response = await deleteNews(id);

      setNotify({
        isOpen: true,
        message: t('main.news_deleted'),
        type: "success",
      });
      setRender(true);
    } catch (error) {

      setNotify({
        isOpen: true,
        message: t('common.error'),
        type: "error",
      });
    }
  };
  let heightinfo = '390';
  let widthinfo = '640';

  if (window.innerWidth <= 768) { 
    heightinfo = '200'; 
    widthinfo = '320'; 
  }
  const opts = {
    height: heightinfo,
    width: widthinfo,
  
    playerVars: {
      autoplay: 0,
      controls: 0,
   
      modestbranding: 1, 
      showRelatedVideos: false,
      howinfo: 0,


      rel: 0, 
    },
 
     
  };
  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return date.format(`[${t('weather.today_word')}] HH:mm`);
     }
    else if(date.isSame(today, 'year')){
      return date.format('DD MMMM HH:mm')
     }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
};

  return (
    <>
    <div className={styles.news_card_wrapper}>
      {[...news].map((item) => {
        return (
          <div className={styles.news_card}>
            <div style={{ width: '100%', maxWidth: '100%', overflowWrap: 'break-word', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
              <p className={styles.title_news}><img src={newswrap} className={styles.img} alt="" ></img>{item.title}</p>
          
            <div className={styles.documents} >
              {!item?.url_video ? (
                ""
              ) : (
                <div style={{
                  fontSize: '14px',
                  display: "flex",
                  gap: "10px",
                  marginBottom:'20px',
                  flexWrap: "wrap",
                 
                  overflow: 'hidden',
                }}>
              
             
                  <YouTube videoId={item?.url_video} opts={opts}  />
              </div>
              
            )}
           </div>
              <pre style={{ whiteSpace: 'pre-wrap', fontSize:'14px'}} >{item.description}</pre>
            </div>
          
            
            <div className={styles.date_footer_div_second}>
            
            <div className={styles.documents} >
                    
              {!item?.url_news ? (
                ""
              ) : (
                <div style={{
                  fontSize: '14px',
                  display: "flex",
                  gap: "10px",
                  marginBottom:'20px',
                  flexWrap: "wrap",
                }}>
                  {t('main.attached_links')}
                {item?.url_news?.split(' ').map((link, index) => (
                   <a  
                   style={{ 
                    textDecoration: "none",
                    wordBreak: "break-all",
                    display: "block",
                    maxWidth: "100%"
                   }}
                   key={index}
                
                   href={link}
                   className={styles.url_news}
                   target="_blank"
               >
                   {link}, 
               </a>
                  ))}
              </div>
              
            )}
           </div>
         
            <div className={styles.documents}>
              {item?.files_news?.length === 0 ? (
                ""
              ) : (

                <div
                  style={{
                    fontSize: '14px',
                    display: "flex",
                    gap: "10px",
                    marginBottom:'20px',
                    flexWrap: "wrap",
                  }}
                >
                  
                  {t('main.attached_files')}
                  {item?.files_news?.map((item, index) => (
                    
                    <a
                      style={{ textDecoration: "none" }}
                      href={item?.file}
                      className={styles.url_news}
                      target="_blank"
                      download={`file_${index}.pdf`}
                    >
                    {decodeURI(item?.file).split("/").slice(-1)[0]}, 
                    </a>
                  ))}
                </div>
                
              )}
            </div>
            <div className={styles.date_footer_div}>
              <div className={styles.user_avatar}>
                
                <p className={styles.date_footer_employee_info}>
                  {" "}

                 {item.employee_name}
                </p>
              </div>

              <p className={styles.date_footer}>
                {" "}
                
                {formatDate(item.date_publication)}
              </p>
            </div>
            {user_info.is_admin_of_news ?
            <button className={styles.delete_btn}  onClick={() => handleDelete(item.id)}>
                        {t('main.delete_btn')}
                      </button>
                      :""}
            </div>
           
          </div>
        );
      })}

      <ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalText={info_card.title}
      >
        <>
          <h4 style={{ paddingTop: "6px" }}>{info_card.description}</h4>

          <div style={{ textAlign: "center" }}>
            <p
              style={{
                fontSize: "12px",
                paddingTop: "6px",
                paddingBottom: "6px",
              }}
            >
              {" "}
              {info_card.date_publication}
            </p>
          </div>

          <Button
            onClick={() => setOpenModal(false)}
            className={styles.btn_pin_close}
          >
            {" "}
            {t('common.close')}
          </Button>
        </>
      </ModalWindow>
      
    </div>
    <Notification notify={notify} setNotify={setNotify} />
    </>
  );
};

export default NewsCard;
